import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=2336348a&scoped=true&"
var script = {}
import style0 from "./Article.vue?vue&type=style&index=0&id=2336348a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2336348a",
  null
  
)

export default component.exports